import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import "../../assets/css/Profile.scss";
import { FaRegUser, FaBoxOpen } from "react-icons/fa";
import { PiAddressBookLight } from "react-icons/pi";
import { GoSignOut } from "react-icons/go";
import ProfileEdit from "./ProfileEdit";
import ProfileOrder from "../Sections/Account/ProfileOrder"; // Import the ProfileOrder component
import MainProfile from "../Sections/Account/MainProfile";
import ProfileAddress from "../Sections/Account/ProfileAddress";
import ProfileSignout from "../Sections/Account/ProfileSignout";
import { Helmet } from "react-helmet";
const Profile = () => {
  const [isEditing, setIsEditing] = useState(false); // State to manage edit mode
  const [currentSection, setCurrentSection] = useState("profile"); // State to track the active section
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on page load
  }, []);
  const profileData = [
    {
      name: "Profile",
      icon: (
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.66797 25.5C5.66797 23.9971 6.26499 22.5558 7.3277 21.4931C8.3904 20.4304 9.83174 19.8334 11.3346 19.8334H22.668C24.1709 19.8334 25.6122 20.4304 26.6749 21.4931C27.7376 22.5558 28.3346 23.9971 28.3346 25.5C28.3346 26.2515 28.0361 26.9722 27.5048 27.5035C26.9734 28.0349 26.2527 28.3334 25.5013 28.3334H8.5013C7.74986 28.3334 7.02919 28.0349 6.49783 27.5035C5.96648 26.9722 5.66797 26.2515 5.66797 25.5Z"
            stroke="#767676"
            stroke-width="1.2"
            stroke-linejoin="round"
          />
          <path
            d="M17 14.1667C19.3472 14.1667 21.25 12.2639 21.25 9.91669C21.25 7.56948 19.3472 5.66669 17 5.66669C14.6528 5.66669 12.75 7.56948 12.75 9.91669C12.75 12.2639 14.6528 14.1667 17 14.1667Z"
            stroke="#767676"
            stroke-width="1.2"
          />
        </svg>
      ),
      section: "profile",
    },
    {
      name: "Orders",
      icon: (
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.90625 16.4871V24.1138L16.9945 26.197V9.57593"
            stroke="#767676"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.0241 16.689V23.9806L16.9961 26.197"
            stroke="#767676"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.72378 21.7203L9.80699 21.942M20.3824 15.6364L29.8642 16.9426C30.0113 16.963 30.1612 16.9437 30.2984 16.8867C30.4356 16.8297 30.555 16.737 30.6443 16.6183C30.7336 16.4996 30.7895 16.3591 30.8063 16.2115C30.8231 16.0639 30.8001 15.9145 30.7397 15.7788L28.0232 9.66448L16.9944 7.80298L5.90761 9.75373L3.26553 15.4317C3.20423 15.5632 3.17833 15.7084 3.19038 15.8529C3.20243 15.9975 3.25202 16.1364 3.33424 16.2559C3.41646 16.3754 3.52846 16.4714 3.65916 16.5343C3.78985 16.5972 3.93471 16.6249 4.0794 16.6146L13.5272 15.958C13.7153 15.945 13.8964 15.8812 14.0511 15.7732C14.2058 15.6653 14.3283 15.5174 14.4055 15.3453L16.9944 9.57665L19.582 15.0499C19.656 15.2065 19.7679 15.3421 19.9075 15.4445C20.0472 15.5469 20.2108 15.6129 20.3824 15.6364Z"
            stroke="#767676"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      section: "orders",
    },
    {
      name: "Addresses",
      icon: (
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.625 0.78125H2.375C1.95231 0.78125 1.54693 0.949162 1.24805 1.24805C0.949162 1.54693 0.78125 1.95231 0.78125 2.375V23.625C0.78125 24.0477 0.949162 24.4531 1.24805 24.752C1.54693 25.0508 1.95231 25.2188 2.375 25.2188H23.625C24.0477 25.2188 24.4531 25.0508 24.752 24.752C25.0508 24.4531 25.2188 24.0477 25.2188 23.625V2.375C25.2188 1.95231 25.0508 1.54693 24.752 1.24805C24.4531 0.949162 24.0477 0.78125 23.625 0.78125ZM20.9688 9.28125H24.1562V16.7188H20.9688V9.28125ZM24.1562 2.375V8.21875H20.9688V1.84375H23.625C23.7659 1.84375 23.901 1.89972 24.0007 1.99935C24.1003 2.09898 24.1562 2.2341 24.1562 2.375ZM1.84375 23.625V2.375C1.84375 2.2341 1.89972 2.09898 1.99935 1.99935C2.09898 1.89972 2.2341 1.84375 2.375 1.84375H19.9062V24.1562H2.375C2.2341 24.1562 2.09898 24.1003 1.99935 24.0007C1.89972 23.901 1.84375 23.7659 1.84375 23.625ZM23.625 24.1562H20.9688V17.7812H24.1562V23.625C24.1562 23.7659 24.1003 23.901 24.0007 24.0007C23.901 24.1003 23.7659 24.1562 23.625 24.1562ZM15.6403 18.1797C15.4513 17.4862 15.1093 16.8439 14.6395 16.2999C14.1698 15.7559 13.5841 15.3241 12.9256 15.036C13.5925 14.5952 14.0996 13.9513 14.3717 13.1996C14.6438 12.448 14.6664 11.6286 14.4363 10.8631C14.2061 10.0976 13.7354 9.42657 13.094 8.94958C12.4525 8.47259 11.6744 8.215 10.875 8.215C10.0756 8.215 9.29751 8.47259 8.65603 8.94958C8.01455 9.42657 7.54385 10.0976 7.31371 10.8631C7.08356 11.6286 7.10622 12.448 7.37833 13.1996C7.65044 13.9513 8.15751 14.5952 8.82437 15.036C8.16632 15.3246 7.58114 15.7566 7.11165 16.3005C6.64217 16.8445 6.30028 17.4865 6.11102 18.1797C6.0759 18.316 6.09631 18.4607 6.16778 18.5819C6.23925 18.7032 6.35593 18.7912 6.49219 18.8265C6.53555 18.8378 6.58018 18.8436 6.625 18.8438C6.74271 18.8437 6.85705 18.8045 6.95008 18.7324C7.04311 18.6603 7.10956 18.5593 7.13898 18.4453C7.55469 16.8516 9.15508 15.6562 10.875 15.6562C12.5949 15.6562 14.202 16.8516 14.6097 18.4453C14.6449 18.582 14.733 18.6991 14.8545 18.7708C14.9761 18.8425 15.1211 18.863 15.2578 18.8278C15.3945 18.7926 15.5116 18.7045 15.5833 18.583C15.655 18.4614 15.6755 18.3164 15.6403 18.1797ZM8.21875 11.9375C8.21875 11.4121 8.37454 10.8986 8.66641 10.4618C8.95828 10.0249 9.37313 9.68449 9.8585 9.48344C10.3439 9.2824 10.8779 9.2298 11.3932 9.33229C11.9085 9.43478 12.3818 9.68776 12.7533 10.0592C13.1247 10.4307 13.3777 10.904 13.4802 11.4193C13.5827 11.9346 13.5301 12.4686 13.3291 12.954C13.128 13.4394 12.7876 13.8542 12.3507 14.1461C11.9139 14.438 11.4004 14.5938 10.875 14.5938C10.1705 14.5938 9.49489 14.3139 8.99675 13.8158C8.4986 13.3176 8.21875 12.642 8.21875 11.9375Z"
            fill="black"
          />
        </svg>
      ),
      section: "addresses",
    },
    {
      name: "Sign out",
      icon: (
        <svg
          width="21"
          height="26"
          viewBox="0 0 21 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 13C0 13.1724 0.0684821 13.3377 0.190381 13.4596C0.312279 13.5815 0.477609 13.65 0.65 13.65H12.0809L8.6398 17.0898C8.57936 17.1501 8.53141 17.2218 8.49867 17.3007C8.46593 17.3796 8.44905 17.4641 8.44899 17.5495C8.44887 17.722 8.51727 17.8875 8.63915 18.0096C8.76103 18.1316 8.9264 18.2002 9.09889 18.2004C9.27138 18.2005 9.43685 18.1321 9.5589 18.0102L14.1089 13.4602C14.2308 13.3383 14.2992 13.173 14.2992 13.0006C14.2992 12.8283 14.2308 12.663 14.1089 12.5411L9.5589 7.9911C9.43631 7.8727 9.27212 7.80718 9.10169 7.80866C8.93126 7.81014 8.76823 7.8785 8.64772 7.99902C8.5272 8.11953 8.45884 8.28256 8.45736 8.45299C8.45588 8.62342 8.5214 8.78761 8.6398 8.9102L12.0809 12.35H0.65C0.477609 12.35 0.312279 12.4185 0.190381 12.5404C0.0684821 12.6623 0 12.8276 0 13ZM17.55 0H3.25C2.38805 0 1.5614 0.34241 0.951903 0.951903C0.34241 1.5614 0 2.38805 0 3.25V8.45C0 8.62239 0.0684821 8.78772 0.190381 8.90962C0.312279 9.03152 0.477609 9.1 0.65 9.1C0.822391 9.1 0.987721 9.03152 1.10962 8.90962C1.23152 8.78772 1.3 8.62239 1.3 8.45V3.25C1.3 2.73283 1.50545 2.23684 1.87114 1.87114C2.23684 1.50545 2.73283 1.3 3.25 1.3H17.55C18.0672 1.3 18.5632 1.50545 18.9289 1.87114C19.2946 2.23684 19.5 2.73283 19.5 3.25V22.75C19.5 23.2672 19.2946 23.7632 18.9289 24.1289C18.5632 24.4946 18.0672 24.7 17.55 24.7H3.25C2.73283 24.7 2.23684 24.4946 1.87114 24.1289C1.50545 23.7632 1.3 23.2672 1.3 22.75V17.55C1.3 17.3776 1.23152 17.2123 1.10962 17.0904C0.987721 16.9685 0.822391 16.9 0.65 16.9C0.477609 16.9 0.312279 16.9685 0.190381 17.0904C0.0684821 17.2123 0 17.3776 0 17.55V22.75C0 23.612 0.34241 24.4386 0.951903 25.0481C1.5614 25.6576 2.38805 26 3.25 26H17.55C18.412 26 19.2386 25.6576 19.8481 25.0481C20.4576 24.4386 20.8 23.612 20.8 22.75V3.25C20.8 2.38805 20.4576 1.5614 19.8481 0.951903C19.2386 0.34241 18.412 0 17.55 0Z"
            fill="#767676"
          />
        </svg>
      ),
      section: "signout",
    },
  ];

  const userData = [
    { user: "Name", userdetails: "Rahul Sharma" },
    { user: "Password", userdetails: ". . . . . ." },
    { user: "Email Id", userdetails: "RahulSharma@gmail.com" },
    { user: "Mobile Number", userdetails: "9999999999" },
    { user: "Date of Birth", userdetails: "20-03-1999" },
    {
      user: "Address",
      userdetails: (
        <>
          Flat No. 12, ABC Apartments, 2nd Cross, MG Road, Koramangala,
          Bangalore - 560034 Karnataka, India
        </>
      ),
    },
  ];

  // Handler for switching to edit mode
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Handler to exit edit mode (on cancel or save)
  const handleExitEdit = () => {
    setIsEditing(false);
  };

  // Render the content of the selected section
  const renderContent = () => {
    if (isEditing) {
      return <ProfileEdit onCancel={handleExitEdit} onSave={handleExitEdit} />;
    }

    switch (currentSection) {
      case "profile":
        return <MainProfile />;
      case "orders":
        return <ProfileOrder />; // Render the ProfileOrder component
      case "addresses":
        return <ProfileAddress />; // Add relevant content for other sections
      case "signout":
        return <ProfileSignout />; // Add relevant content for signout or logout action
      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>My Account | D'decor Rugs</title>
        <meta property="og:title" content="My Account | D'decor Rugs" />
      </Helmet>
      <Header />
      <div className="profile-page-container">
        <div className="header-of-login">
          <p>Home - My account</p>
        </div>
        <div className="header-of-login-mobile-view">
          <p>Home - My account</p>
        </div>
        <div className="profile-main-content">
          <div className="profile-menu-icons">
            {profileData.map((item, index) => (
              <div
                className={`icons-details ${
                  currentSection === item.section ? "active" : ""
                }`}
                key={index}
                onClick={() => setCurrentSection(item.section)} // Set the active section
              >
                {item.icon}
                <p>{item.name}</p>
              </div>
            ))}
          </div>
          <div className="border-div"></div>
          {renderContent()}{" "}
          {/* Conditionally render content based on the active section */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
